import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmFromUrl } from '@/lib/utmCapture';
import { trackEvent } from '@/lib/trackEvent';

/**
 * Captures UTM query params into localStorage and fires a lightweight landing event once per tab.
 */
export default function UtmBootstrap() {
  const location = useLocation();
  const landingOnce = useRef(false);

  useEffect(() => {
    captureUtmFromUrl();
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (landingOnce.current) return;
    landingOnce.current = true;
    void trackEvent('landing_page_view', {
      meta: { path: location.pathname },
    });
  }, [location.pathname]);

  return null;
}
